module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "mo-upload"
  }, [_c('input', {
    attrs: {
      "type": "file",
      "accept": _vm.accepts
    },
    on: {
      "change": _vm.upload
    }
  }), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5d50e048"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/file_upload.vue
// module id = 846
// module chunks = 1